// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  dbVersion: 9,
  dashboardCacheVersion: 7,
  production: false,
  apiUrl: 'https://speedbox-api-play.azurewebsites.net',
  acceptHeader: 'application/vnd.speedbox.v' + 2 + '+json',
  appUrl: 'https://wonderful-plant-0b6677003.5.azurestaticapps.net',
  /** Hardware contact older than this is Offline. Matches the API hardware contact timeout and the Watchdog default. */
  offlineThreshold: 5 * 60 * 1000, // 5 minutes
  /** Hardware contact older than this is Pending (Watchdog only). */
  pendingThreshold: 2 * 60 * 1000, // 2 minutes
  whiteListedGlobalAdminIds: [
    'a4355b16-39a3-4a92-af60-52b4fccb4e52',
    'd807e62d-cd92-44e0-bb4c-2fdaaa80cda0',
  ],
  /** post-session refund UI — temporary allowlist until API is generally available. */
  postSessionRefundAllowedUserIds: [
    'd807e62d-cd92-44e0-bb4c-2fdaaa80cda0',
    'fef80d1e-383f-45d7-b1ae-82f1bcd91fe3',
  ],
  /** Esper Console link on Duo payment terminals — temporary allowlist. */
  esperConsoleAllowedUserIds: [
    'fef80d1e-383f-45d7-b1ae-82f1bcd91fe3',
    'd807e62d-cd92-44e0-bb4c-2fdaaa80cda0',
  ],
  /** Watchdog UI — temporary allowlist until the feature is generally available. */
  watchdogAllowedUserIds: [
    '5e451d9b-db62-445b-a8ff-0549c97587dd',
    'd807e62d-cd92-44e0-bb4c-2fdaaa80cda0',
    'f2915582-611f-4742-a2bb-b15a8b371ca3',
    'a4355b16-39a3-4a92-af60-52b4fccb4e52',
  ],
  /** Review changes on settings pages — temporary allowlist. */
  settingsReviewChangesAllowedUserIds: [
    'a4355b16-39a3-4a92-af60-52b4fccb4e52',
    'fef80d1e-383f-45d7-b1ae-82f1bcd91fe3',
  ],
  csatIdsToIgnore: [
    'd7c838c7-b08a-428b-bd64-5aa5f9090d21',
    '00a01b9f-ff9f-4ead-96e2-2fdb349d2b4d',
    '6a0a5d88-8623-43be-8885-6d1b6bcb0d6b',
    '571e3342-8322-40ab-9dfe-a46de41958e1',
    '7581cbf0-3c9e-4e29-87fe-67b66f66ba3f',
    '38bf1011-8859-4b87-9e45-01418390eb0a',
    'aaa55b16-39a3-4a92-af60-52b4fccb4222',
    '40c96df4-6b0d-466a-b3cb-6fbf79ff0920',
    '4ae7fd32-02e7-4f27-9348-f83bd02f66fd',
    'a4355b16-39a3-4a92-af60-52b4fccb4e52',
    'f2915582-611f-4742-a2bb-b15a8b371ca3',
    'b851cb3c-14a4-4a96-a665-73176300dea0',
    'd807e62d-cd92-44e0-bb4c-2fdaaa80cda0',
    'adaa49a8-a7c1-4eef-9a83-2a32d186fd61',
    '9e1e7cc9-5e2c-496e-b957-1c07e27944e3',
    'abb653c7-717b-4354-b74a-c3c01c483f64',
    '76ed0fa5-ab42-45d8-bbaa-b9d3978a7fb8',
    '7914c424-b687-443d-8cd9-259f9ee6c05b',
    '46b8f0a3-304f-43e9-af8b-1da7f9c12f70',
    '3b32837e-9fb7-45b9-83e2-c0da04ae48a3',
    '679e5913-e897-499f-909c-3a7a7456a6c2',
  ],
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *,
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
